import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { DeskScene } from "./DeskScene";
import { GameIntroScene } from "./GameIntro";
import { OrganizeDeskGameConfig, GameState } from "../objects/GameState";
import { Utilities } from "../objects/Utilities";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.OrganizeDesk;
        this.mainScene = DeskScene;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "OrganizeDesk.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "OrganizeDesk.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "OrganizeDesk.Phaser.HowToPlay.tabletInstructions";
    }

    create() {
        super.create();

        /** JB: Note
         * Required because this game was made before we really standardized the process.
         * This properly loads the gamestate, starting at desk 1 when moving to the next scene
         */

        // Game config for the first desk
        var deskOrder = Utilities.getRandomDeskOrder();
        var firstDesk = deskOrder.pop();
        var deskSupplies = Utilities.initializeDeskSupplies();
        var deskGarbageItems = Utilities.initializeGarbageItems();
        let config: OrganizeDeskGameConfig = {
            deskOrder: deskOrder,
            mapKey: "desk_" + firstDesk,
            deskSupplies: deskSupplies,
            deskGarbageItems: deskGarbageItems,
            spill: true,
        };
        GameState.current = new GameState(config);
    }
}



// WEBPACK FOOTER //
// ./src/games/OrganizeDeskGame/scenes/MainScene.ts